module.exports = "./static/img_personal_bg.7723b100.png";